import { StyleSheet } from 'react-native'

import { B5, colors, Stack } from '@zet/design-system'
import Pressable from '@zet/design-system/pressable'
import ZetCoinsFilled from '@zet/homepage-widgets/src/assets/svg/zetCoinsFilled.svg'
import { i18n } from '@zet/localization'
import { currencyFormatConvertor } from '@zet/utils/stringConversion'

interface ICoinsCondition {
  onCoinsLimitKnowMore: () => void
  coinsLimit: {
    minimumBasePayout?: number
    coinsLimit: number
    coinsLimitExceeded: boolean
    isPayoutEligibleForCoins: boolean
    limitType: string
  }
}

const CoinsConditionCard = ({
  onCoinsLimitKnowMore,
  coinsLimit,
}: ICoinsCondition) => {
  return (
    <Stack className="border-grays-30 mx-3 my-2 flex-1 items-center rounded border pb-2">
      <B5
        className="bg-grays-30 mx-2  mt-2 self-start rounded p-2"
        style={styles.coinsBorder}
      >
        <Stack>
          <ZetCoinsFilled className="top-1 mr-1" height={19} width={19} />
        </Stack>
        {i18n.t('payoutBreakoutLoyalty.zetCoins')}
      </B5>
      <B5 className="text-grays-70 mt-2 flex-1 self-start px-2">
        {coinsLimit?.coinsLimitExceeded
          ? i18n.t('weeklyLimit', {
              minCoins:
                currencyFormatConvertor(coinsLimit?.coinsLimit?.toString()) ||
                '10,000',
              time: coinsLimit?.limitType || 'weekly',
            })
          : i18n.t('minimumBasePayout', {
              minBasePayout: coinsLimit?.minimumBasePayout || 251,
            })}
        <Pressable onPress={onCoinsLimitKnowMore}>
          <B5 className="text-grays-80 top-1 underline">
            {i18n.t('knowMore')}
          </B5>
        </Pressable>
      </B5>
    </Stack>
  )
}

const styles = StyleSheet.create({
  sideBorder: {
    borderColor: colors.success[50],
  },
  coinsBorder: {
    borderColor: colors.success[30],
  },
  failedErrorBorder: {
    borderColor: colors.error[20],
  },
})

export default CoinsConditionCard
